module.exports = __webpack_public_path__ + "img/smiling.49da6369.jpeg";